import { render, staticRenderFns } from "./label-scrapped-modal.vue?vue&type=template&id=7371f5cf"
import script from "./label-scrapped-modal.vue?vue&type=script&lang=js"
export * from "./label-scrapped-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports